module.exports = __webpack_public_path__ + "img/hdjjBg.ad677c61.png";